import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Villa Nomade Les Portes en Ré - Location Vacances Île de Ré", 
  description = "Villa de luxe 4 chambres avec spa de nage aux Portes en Ré, île de Ré. Proche golf de Trousse Chemise et plages. Location saisonnière idéale pour 8 personnes.",
  keywords = "villa ile de ré, location portes en ré, villa nomade, golf trousse chemise, location vacances ile de ré, spa ile de ré, villa avec piscine ile de ré, location saisonnière charente maritime",
  image = "/images/villa/villa-exterior-v2.jpg",
  ogImage,
  url
}) => {
  const siteUrl = "https://villa-nomade-ile-de-re.fr";
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const fullImage = ogImage || (image.startsWith('http') ? image : `${siteUrl}${image}`);
  
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Villa Nomade" />
      <meta property="og:locale" content="fr_FR" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />

      {/* Additional SEO Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="French" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content="Villa Nomade" />
      
      {/* Geo Tags */}
      <meta name="geo.region" content="FR-17" />
      <meta name="geo.placename" content="Les Portes-en-Ré" />
      <meta name="geo.position" content="46.241667;-1.526667" />
      <meta name="ICBM" content="46.241667, -1.526667" />

      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "TouristAttraction",
          "name": "Villa Nomade",
          "description": "Villa de vacances luxueuse aux Portes en Ré avec spa de nage, 4 chambres, proche du golf de Trousse Chemise",
          "image": fullImage,
          "url": fullUrl,
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Les Portes-en-Ré",
            "postalCode": "17880",
            "addressCountry": "FR"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "46.241667",
            "longitude": "-1.526667"
          },
          "amenityFeature": [
            {
              "@type": "LocationFeatureSpecification",
              "name": "Spa de nage chauffé",
              "value": true
            },
            {
              "@type": "LocationFeatureSpecification",
              "name": "4 chambres",
              "value": true
            },
            {
              "@type": "LocationFeatureSpecification",
              "name": "3 salles de bain",
              "value": true
            },
            {
              "@type": "LocationFeatureSpecification",
              "name": "Parking 3 places",
              "value": true
            }
          ]
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
